import {Component, inject} from '@angular/core';
import {ActiveUserService} from "../../services/active-user.service";
import {MatListModule} from "@angular/material/list";
import {AsyncPipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {MatIcon} from "@angular/material/icon";
import {AdminNavComponent} from "./admin-nav/admin-nav.component";
import {MatLine} from "@angular/material/core";

@Component({
  selector: 'app-side-nav',
  standalone: true,
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  imports: [
    MatListModule,
    AsyncPipe,
    RouterLink,
    MatIcon,
    AdminNavComponent,
    MatLine
  ]
})
export class SideNavComponent {

  private activeUserService: ActiveUserService = inject(ActiveUserService);
  public userIsLoggedIn$ = this.activeUserService.userIsLoggedIn();
  public activeUser$ = this.activeUserService.selectActiveUser();

}
